export enum FleetEventKeys {
	CORE = 'AGX_CORE_VERSION',
	PLC = 'PLC_FIRMWARE',
}
